module.exports = __webpack_public_path__ + "static/media/palestras.1c319536.md";